import { useNavigate } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

export default function ContactUs() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <section className="relative py-20 md:py-24 bg-background-50">
          <div className="max-w-xl mx-auto px-6 md:px-10">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 hover:bg-background-200 text-sm font-medium text-foreground-600 transition-colors cursor-pointer whitespace-nowrap mb-10"
            >
              <i className="ri-arrow-left-line"></i>
              返回主頁
            </button>

            <div className="mb-10">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-semibold tracking-widest uppercase mb-6 whitespace-nowrap">
                <i className="ri-mail-line"></i>
                Contact · 聯絡我們
              </div>
              <h1 className="font-heading text-3xl md:text-4xl font-medium text-foreground-950 leading-tight">
                聯絡我們（Contact Us）
              </h1>
            </div>

            <div className="rounded-2xl bg-background-100 border border-background-200/70 p-8 md:p-10 space-y-5">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                如果你對我們的內容有任何查詢、合作意向或建議，歡迎透過以下電郵地址與我們聯絡，我們會在 48 小時內盡快回覆你。
              </p>

              <div className="flex items-center gap-3 pt-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 shrink-0">
                  <i className="ri-mail-send-line text-lg"></i>
                </div>
                <a
                  href="mailto:1mindlabhugtree@gmail.com"
                  className="text-base md:text-lg font-medium text-primary-600 hover:text-primary-700 underline underline-offset-4 decoration-primary-300 transition-colors cursor-pointer break-all"
                >
                  1mindlabhugtree@gmail.com
                </a>
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-background-200/60">
              <p className="text-sm text-foreground-500">
                或者，你可以直接追蹤我哋嘅 Instagram：
                <a
                  href="https://instagram.com/1mindlab"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-1 font-medium text-primary-600 hover:text-primary-700 transition-colors"
                >
                  @1mindlab
                </a>
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}